/* eslint-disable camelcase */
import {
  useState,
  useEffect,
} from 'react';
import i18n from 'i18next';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from '../styled';

type Props = {
  folder: any,
  indent?: number,
  initialState?: boolean,
  selectedId: number,
  onSelect: { (id: number): void },
};

const Folder = ({
  folder,
  indent = 0,
  initialState = false,
  selectedId,
  onSelect,
}: Props) => {
  if (!folder?.id) {
    return null;
  }

  const [isOpen, setOpen] = useState(initialState);
  const noEmpty = folder.children?.filter(f => !f.selected).length > 0;
  const isDisable = folder.selected
    || folder.children?.some(f => f.selected);

  useEffect(() => {
    if (!selectedId) {
      onSelect(folder.id);
    }
  }, []);

  return (
    <Flex
      column
      shrink="0"
      width="100%"
      spacing={5}
      style={{
        paddingLeft: indent,
      }}
    >
      <S.Folder
        isDisable={isDisable}
        isSelected={folder.id === selectedId}
      >
        <Flex
          align="center"
          width="38px"
          shrink="0"
          spacing={5}
          justify="flex-end"
          onClick={() => ((noEmpty || isDisable)
            ? setOpen(!isOpen)
            : onSelect(folder.id))}
        >
          {noEmpty && (
            <>
              {isOpen ? (
                <SVG.ChevronDown size={16} />
              ) : (
                <SVG.ChevronRight size={16} />
              )}
            </>
          )}
          <SVG.Folder size={14} />
        </Flex>
        <Text
          color={isDisable ? '#b3b3b3' : '#808080'}
          onClick={() => {
            if (!isDisable) {
              onSelect(folder.id);
            }
          }}
        >
          {folder.is_root ? i18n.t(folder.name) : folder.name}
        </Text>
      </S.Folder>
      {isOpen && noEmpty && (
        <Flex
          column
          shrink="0"
          spacing={10}
          width="100%"
        >
          {folder.children.filter(f => !f.selected).map(f => (
            <Folder
              key={f.id}
              folder={f}
              indent={20}
              selectedId={selectedId}
              onSelect={onSelect}
            />
          ))}
        </Flex>
      )}
    </Flex>
  );
};

export default Folder;
